export const INVALID_EMAIL_MESSAGE = 'Please enter a valid email address'

export const isValidEmailFormat = (email: string) =>
  !!email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
